import { Grid } from "@mui/material";
import MxFormFieldController from "@rf-l2/form/MxFormFieldController";
import MxFormTextDateField from "@rf-l2/form/text-fields/MxFormTextDateField";
import MxFormErrorIconsMessage from "@rf-l2/form/MxFormErrorIconsMessage";
import { useBuildingDetail } from "../../context/BuildingDetailContext";
import { memo } from "react";
import { CPropertyBuildingFormKeys } from "@rf/property/module/components/property-form/util/schemas/building-form/building.schema";

const BuildingDeliveryDateField = memo(() => {
  const { nameBuilding } = useBuildingDetail();

  return (
    <Grid item xs={12}>
      <MxFormFieldController
        name={`${nameBuilding}.${CPropertyBuildingFormKeys.dateDelivery}`}
        withreacthookform={1}
      >
        <Grid container spacing={1} alignItems="center" wrap="nowrap">
          <Grid item xs={11}>
            <MxFormTextDateField backgroundColor="white" />
          </Grid>
          <Grid item xs="auto">
            <MxFormErrorIconsMessage />
          </Grid>
        </Grid>
      </MxFormFieldController>
    </Grid>
  );
});

export default BuildingDeliveryDateField;
